import { connect } from 'react-redux';
import {
  loadCustomerOrganization,
  loadCustomerOrganizationUsersList,
  loadCustomerOrganizationUsersListPage,
  createCustomerOrganizationUser,
  deleteCustomerOrganizationUser,
  inviteCustomerOrganizationUser,
  addFPsCustomerOrganizationUser,
  notifySubscriptionExpiredCustomerOrganizationUser,
  updateCustomerOrganizationUser,
  loadUsersInfoForStaffMember,
  transrUserFromOrgtoAnother,
} from '../../redux/actions/staff';
import CustomerUsers from './components/Users';

const mapStateToProps = (state) => ({
  customerOrganizationStatus: state.staff.customerOrganizationStatus,
  customerOrganizationData: state.staff.customerOrganizationData,
  customerOrganizationUsersStatus: state.staff.customerOrganizationUsersStatus,
  customerOrganizationUsersData: state.staff.customerOrganizationUsersData,
  customerOrganizationUsersCount: state.staff.customerOrganizationUsersCount,
  createCustomerOrganizationUserStatus:
    state.staff.createCustomerOrganizationUserStatus,
  createCustomerOrganizationUserData:
    state.staff.createCustomerOrganizationUserData,
  updateCustomerOrganizationUserStatus:
    state.staff.updateCustomerOrganizationUserStatus,
  updateCustomerOrganizationUserData:
    state.staff.updateCustomerOrganizationUserData,
  usersInfoForStaffMember: state.staff.usersInfoForStaffMember,
  usersInfoForStaffMemberStatus: state.staff.usersInfoForStaffMemberStatus,
});

const mapDispatchToProps = {
  loadCustomerOrganization,
  loadCustomerOrganizationUsersList,
  loadCustomerOrganizationUsersListPage,
  createCustomerOrganizationUser,
  deleteCustomerOrganizationUser,
  inviteCustomerOrganizationUser,
  addFPsCustomerOrganizationUser,
  notifySubscriptionExpiredCustomerOrganizationUser,
  updateCustomerOrganizationUser,
  loadUsersInfoForStaffMember,
  transrUserFromOrgtoAnother,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerUsers);
